var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9101c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca0814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f7811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a650c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v3.809524h-16z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.66933973 6.0952381c-.03199733-.16568679-.05029211-.3120457-.05029211-.38095239 0-.21039418.17055817-.38095238.38095238-.38095238s.38095238.1705582.38095238.38095238c0 .06890669-.01829478.2152656-.05029211.38095239h.43475763c.20845395 0 .37743924.1767113.37743924.38095238 0 .21039418-.16438293.38095238-.37743924.38095238h-1.53083582c-.20845393 0-.37743922-.17671131-.37743922-.38095238 0-.21039419.16438293-.38095238.37743922-.38095238zm-.43124449-.76190477c-.21039419 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.1705582.38095238.38095238 0 .21039419-.1705582.38095238-.38095238.38095238zm1.52380952 0c-.21039421 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055817-.38095238.38095238-.38095238s.38095238.1705582.38095238.38095238c0 .21039419-.17055817.38095238-.38095238.38095238zm1.52380954.76190477c-.2103942 0-.3809524-.1705582-.3809524-.38095239 0-.21039418.1705582-.38095238.3809524-.38095238s.3809524.1705582.3809524.38095238c0 .21039419-.1705582.38095239-.3809524.38095239zm-4.57142859 0c-.21039418 0-.38095238-.1705582-.38095238-.38095239 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095239.1705582.38095239.38095238 0 .21039419-.1705582.38095239-.38095239.38095239z",
    fill: "#fad14e",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/TJ.f7aac4c5fe9140638e036e06115a8f8f.svg";
export { ForwardRef as ReactComponent };